import { Link } from 'react-router-dom';
import type { Film } from '@/types/film';
import { typeLabel } from '@/lib/film';

interface FilmCardProps {
  film: Film;
  className?: string;
  showSynopsis?: boolean;
}

export default function FilmCard({ film, className = '', showSynopsis = true }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className={`group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300 ${className}`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-primary-950">
        <img
          src={film.cover}
          alt={`${film.title} 封面`}
          title={`${film.title} - 青青草影视详情`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-primary-950/85 to-transparent" />
        <span className="absolute left-2.5 top-2.5 rounded-md bg-primary-950/70 px-2 py-0.5 text-[11px] font-medium text-background-100 backdrop-blur-sm">
          {typeLabel(film.type)}
        </span>
        <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-primary-950">
          <i className="ri-star-fill text-[10px]" />
          {film.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2.5 left-2.5 rounded-md bg-background-50/90 px-2 py-0.5 text-[11px] font-medium text-primary-700">
          {film.year}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 px-3 pb-3.5 pt-3">
        <h3 className="line-clamp-1 font-heading text-[15px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {film.title}
        </h3>
        <p className="line-clamp-1 text-xs text-foreground-500">
          {film.genres.slice(0, 2).join(' / ')} · {film.region}
        </p>
        {showSynopsis && (
          <p className="line-clamp-2 text-xs leading-relaxed text-foreground-400">{film.synopsis}</p>
        )}
      </div>
    </Link>
  );
}